// client/src/routes/_auth/register.tsx — SCR-AUTH-002 „Creează un cont" · AUTH-004, reshaped by D-1530.
//
// The deep link is read here exactly as `/login` reads it (D-1625). An invitation is the only
// way into somebody else's portfolio, and its page offers „Creează un cont" carrying
// `redirect=/invite/<token>`: a route that did not validate the param dropped it, the form
// landed on the wizard, and the person had to find the mail again to spend a token they had
// already clicked.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { landingFor, redirectSearchSchema, safeRedirect } from '@/features/auth/redirect';
import { RegisterForm } from '@/features/auth/RegisterForm';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/register')({
  validateSearch: redirectSearchSchema,
  // A visitor who already holds a session has nothing to sign up for; the deep link they
  // carried is honoured the same way it would have been after the signup itself.
  beforeLoad: async ({ search }) => {
    const session = await ensureSession();
    if (session) throw redirect({ href: safeRedirect(search.redirect, landingFor(session)) });
  },
  component: RegisterScreen,
});

function RegisterScreen() {
  const search = Route.useSearch();
  return <RegisterForm search={search} />;
}
